<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import type { NuxtError } from '#app'

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true
  }
})

useHead({
  htmlAttrs: {
    lang: 'fr'
  }
})

useSeoMeta({
  title: props.error.statusMessage,
  description: props.error.message,
})


</script>

<template>
  <Header />
  <div>
    <UMain>
      <UContainer>
        <UPage>
          <UError :error="{statusCode : error.statusCode, statusMessage: error.statusCode == 404 ? 'Page introuvable' : 'Erreur'}" :clear="{ label: 'Retour à l\'accueil'}" />
        </UPage>
      </UContainer>
    </UMain>
  </div>
  <Footer />
</template>